import { call, put, select, takeLatest } from 'redux-saga/effects';
import { goto } from '../../../actions/historyActions';
import { myAxaFetchWithToken } from '../../../utils/myAxaFetchWithToken';
import {
  getAktivoDisclaimerCustState,
  getDisclaimerInfoApiUrl,
} from '../selectors/aktivoOnboardingSelectors';
import {
  AKTIVO_BACK,
  AKTIVO_SHOW_MY_WELLNESS,
  FETCH_AKTIVO_CUSTOMER_STATE,
  FETCH_AKTIVO_CUSTOMER_STATE_SUCCESS,
  toggleAktivoModelDisplay,
  AKTIVO_ENTER_DEEPLINK_WITH_CHECKING,
} from '../actions';
import { LOCATION_CHANGE } from 'connected-react-router';
import { getAxaGoalInsuredPolicies } from '../../../selectors/userSelectors';

function* back(): Iterable<any> {
  window.history.back();
}

function* checkAndGoToDeeplink(deeplink: string) {
  const custValue = yield call(fetchDisclaimerCustState);
  const axaGoalPolicies = yield select(getAxaGoalInsuredPolicies);
  if (custValue && custValue.isAcceptedAktivoTnc) {
    // has axa goal insured policy and need to check if the user has agreed tnc
    if (axaGoalPolicies.length) {
      // has saved record in customer state and need to check if accepted at least one policy
      if (custValue.policies && custValue.policies.length) {
        const isAcceptedAxaGoalTnc = axaGoalPolicies.reduce(
          (result: boolean, p: any) => {
            const matched = custValue.policies.find(
              (cp: any) => cp.policyNumber === p.policyNumber,
            );
            if (
              matched &&
              (matched.isAcceptedAxaGoalTnc || matched.isAcceptedSilverHairTnc)
            ) {
              return true;
            }
            return result;
          },
          false,
        );
        if (isAcceptedAxaGoalTnc) {
          yield goto(deeplink);
          return;
        }
      }
    } else {
      yield goto(deeplink);
      return;
    }
  }
  yield put(toggleAktivoModelDisplay(true));
}

function* showMyWellnessDashboard() {
  yield call(checkAndGoToDeeplink, 'aktivo-my-wellness/home');
}

function* enterDeeplinkSaga(payload: any) {
  if (payload && payload.url) {
    yield call(checkAndGoToDeeplink, payload.url);
  }
}

function* fetchDisclaimerCustState(): any {
  let custValue = yield select(getAktivoDisclaimerCustState);
  if (Object.keys(custValue).length === 0) {
    try {
      const disclaimerUrl = yield select(getDisclaimerInfoApiUrl);
      const res = yield call(myAxaFetchWithToken, disclaimerUrl, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      });
      const data = yield res.json();
      if (!data) throw new Error();
      const customerState =
        (data && data.length > 0 && data[0].custValue) || '{}';
      custValue = JSON.parse(customerState);
      yield put({
        type: FETCH_AKTIVO_CUSTOMER_STATE_SUCCESS,
        disclaimerCustState: custValue,
      });
      return custValue;
    } catch (e) {}
    return {};
  }
  return custValue;
}

function* aktivoModalSaga(action: any): Iterable<any> {
  if (action.payload.location.hash === '#aktivo-intro') {
    yield put(toggleAktivoModelDisplay(true));
    window.history.back();
  }
}

function* aktivoOnboardingSaga() {
  yield takeLatest(AKTIVO_BACK, back);
  yield takeLatest(AKTIVO_SHOW_MY_WELLNESS, showMyWellnessDashboard);
  yield takeLatest(FETCH_AKTIVO_CUSTOMER_STATE, fetchDisclaimerCustState);
  yield takeLatest(LOCATION_CHANGE, aktivoModalSaga);
  yield takeLatest(AKTIVO_ENTER_DEEPLINK_WITH_CHECKING, enterDeeplinkSaga);
}

export default aktivoOnboardingSaga;
